import { create } from "zustand";

export type AssociateMessageFilters = {
  lifecycle?: {
    category: string;
    values: string[];
  };
  section?: string;
};

export type AssociateMessagePayload = {
  moduleId?: string | number;
  filters?: AssociateMessageFilters;
};

type ProcessMessageStore = {
  associateMessageData?: AssociateMessagePayload;
  setProcessMessage: (params: AssociateMessagePayload) => void;
};

export const useProcessMessageStore = create<ProcessMessageStore>((set) => ({
  associateMessageData: undefined,
  setProcessMessage(data) {
    let normalizedModuleId: string | undefined;
    if (data.moduleId !== null && typeof data.moduleId !== "undefined") {
      normalizedModuleId = String(data.moduleId);
    }

    set(() => ({
      associateMessageData: {
        moduleId: normalizedModuleId,
        filters: data.filters,
      },
    }));
  },
}));

